/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <ModalExito v-show="mostrarExito" :mostrarExito="mostrarExito" />
  <ModalConfirmacion v-if="mostrarModalConfirmacion" @confirmar="eliminarProveedor" @cancelar="cancelarEliminacion"
    :nombreUsuario="nombreProveedor" />
  <LoadScreen v-if="mostrarLoaderDos" />

  <LayoutPrincipal>

    <ContainerWhite>

      <div class="header-proveedores">
        <div class="tituloModulo">Módulo de Proveedores</div>
        <button class="btn-agregar-top" @click="mostrarAddProveedor('')">
          Agregar Proveedor
        </button>
      </div>


      <div class="leyenda-referencia">
        <span class="icono-info">ⓘ</span>
        Los datos mostrados son de referencia
      </div>

      <div class="contenedor-tres-tablas">

        <section class="seccion-tabla-individual">
          <h3 class="subtitulo-tabla">Eléctricos</h3>

          <TablaProveedores :listaProveedores="filteredElectrico" :mostrarLoaderInterno="mostrarLoaderInterno"
            @editar="mostrarEditar" @eliminar="confirmarEliminacion" @detalles="mostrarTabla" :Tipo="'Electrico'" />

          <div v-if="filteredElectrico.length === 0" class="area-agregar-proveedor">
            <button class="btn-agregar-principal" @click="mostrarAddProveedor('Electrico')">
              Agregar Proveedor
            </button>
          </div>
        </section>

        <section class="seccion-tabla-individual">
          <h3 class="subtitulo-tabla">Fotovoltaicos</h3>

          <TablaProveedores :listaProveedores="filteredFotovoltaico" :mostrarLoaderInterno="mostrarLoaderInterno"
            @editar="mostrarEditar" @eliminar="confirmarEliminacion" @detalles="mostrarTabla" :Tipo="'Fotovolcaico'" />

          <div v-if="filteredFotovoltaico.length === 0" class="area-agregar-proveedor">
            <button class="btn-agregar-principal" @click="mostrarAddProveedor('Fotovolcaico')">
              Agregar Proveedor
            </button>
          </div>
        </section>

        <section class="seccion-tabla-individual">
          <h3 class="subtitulo-tabla">Ferreteros</h3>

          <TablaProveedores :listaProveedores="filteredFerretero" :mostrarLoaderInterno="mostrarLoaderInterno"
            @editar="mostrarEditar" @eliminar="confirmarEliminacion" @detalles="mostrarTabla" :Tipo="'Ferreteria'" />

          <div v-if="filteredFerretero.length === 0" class="area-agregar-proveedor">
            <button class="btn-agregar-principal" @click="mostrarAddProveedor('Ferreteria')">
              Agregar Proveedor
            </button>
          </div>
        </section>
      </div>

    </ContainerWhite>

    <AgregarProveedor v-if="mostrarModalAgregar" :tipoInicial="tipoParaAgregar" @cancelar="mostrarModalAgregar = false"
      @guardado="agregarProveedor" />

    <EditarProveedor v-if="mostrarModalEditar" :proveedor="proveedorSeleccionado" @cancelar="mostrarModalEditar = false"
      @actualizar="manejarActualizacion" />
    <TablaProveedor v-if="mostrarModalTablaDetalles" :ferreteria="proveedorSeleccionadoTabla"
      @cancelar="mostrarModalTablaDetalles = false" />

  </LayoutPrincipal>
</template>

<script>
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import ContainerWhite from "../layouts/ContainerWhite.vue";
import AgregarProveedor from "../components/Proveedores/AgregarProveedor.vue";
import EditarProveedor from "../components/Proveedores/EditarProveedor.vue";
import ModalExito from "../components/Modales/ModalExito.vue";
import ModalConfirmacion from "../components/Modales/ModalConfirmacion.vue";
import LoadScreen from "../components/Forms/LoadScreen.vue";
import TablaProveedor from "../components/Proveedores/TablaProveedor.vue";
import TablaProveedores from "../components/Proveedores/TablaProveedores.vue";
import providerService from "../services/providerService.js";

export default {
  components: {
    LayoutPrincipal,
    ContainerWhite,
    AgregarProveedor,
    EditarProveedor,
    ModalExito,
    ModalConfirmacion,
    LoadScreen,
    TablaProveedor,
    TablaProveedores,
  },
  data() {
    return {
      searchText: "",
      proveedoresElectricos: [],
      proveedoresFotovoltaicos: [],
      proveedoresFerreteros: [],
      mostrarModalAgregar: false,
      mostrarModalEditar: false,
      mostrarModalConfirmacion: false,
      mostrarLoaderDos: false,
      mostrarLoaderInterno: false,
      mostrarExito: false,
      proveedorSeleccionado: null,
      nombreProveedor: "",
      mostrarModalTablaDetalles: false,
      proveedorSeleccionadoTabla: null,
      TipoProveedorAEliminar: null,
      tipoParaAgregar: ''
    };
  },
  computed: {
    filterList() {
      const term = this.searchText.toLowerCase();
      return (list) => list.filter(
        (p) =>
          p.Nombre.toLowerCase().includes(term) ||
          p.id_proveedor.toString().padStart(3, '0').includes(term)
      );
    },
    filteredElectrico() { return this.filterList(this.proveedoresElectricos); },
    filteredFotovoltaico() { return this.filterList(this.proveedoresFotovoltaicos); },
    filteredFerretero() { return this.filterList(this.proveedoresFerreteros); },
  },
  methods: {
    async obtenerProveedores() {
      this.mostrarLoaderInterno = true;
      try {
        const response = await providerService.getAllProviders();
        const allProviders = response.data;

        this.proveedoresElectricos = allProviders.filter((p) => p.Tipo === 'Electrico');
        this.proveedoresFotovoltaicos = allProviders.filter((p) => p.Tipo === 'Fotovolcaico');
        this.proveedoresFerreteros = allProviders.filter((p) => p.Tipo === 'Ferreteria');

      } catch (error) {
        console.error("Error al cargar los proveedores:", error);
      } finally {
        this.mostrarLoaderInterno = false;
      }
    },
    getListaPorTipo(Tipo) {
      switch (Tipo) {
        case "Fotovolcaico": return this.proveedoresFotovoltaicos;
        case "Ferreteria": return this.proveedoresFerreteros;
        case "Electrico": return this.proveedoresElectricos;
        default: return [];
      }
    },
    mostrarAddProveedor(Tipo) {
      this.tipoParaAgregar = Tipo;
      this.mostrarModalAgregar = true;
    },
    mostrarEditar(id_proveedor, Tipo) {
      const proveedor = this.getListaPorTipo(Tipo).find(p => p.id_proveedor === id_proveedor);
      if (proveedor) { this.proveedorSeleccionado = { ...proveedor }; this.mostrarModalEditar = true; }
    },
    mostrarTabla(id_proveedor, Tipo) {
      const proveedor = this.getListaPorTipo(Tipo).find(p => p.id_proveedor === id_proveedor);
      if (proveedor) { this.proveedorSeleccionadoTabla = { ...proveedor }; this.mostrarModalTablaDetalles = true; }
    },
    confirmarEliminacion(proveedor, Tipo) {
      this.proveedorSeleccionado = proveedor;
      this.nombreProveedor = proveedor.Nombre;
      this.TipoProveedorAEliminar = Tipo;
      this.mostrarModalConfirmacion = true;
    },
    async eliminarProveedor() {
      this.mostrarModalConfirmacion = false;
      this.mostrarLoaderDos = true;
      try {
        const idAEliminar = this.proveedorSeleccionado.id_proveedor;
        const Tipo = this.TipoProveedorAEliminar;

        await providerService.deleteProvider(idAEliminar);

        let listaReferencia;
        if (Tipo === 'Electrico') listaReferencia = 'proveedoresElectricos';
        else if (Tipo === 'Fotovolcaico') listaReferencia = 'proveedoresFotovoltaicos';
        else if (Tipo === 'Ferreteria') listaReferencia = 'proveedoresFerreteros';

        if (listaReferencia) {
          this[listaReferencia] = this[listaReferencia].filter(
            (p) => p.id_proveedor !== idAEliminar
          );
        }

        this.mostrarExito = true;
        setTimeout(() => (this.mostrarExito = false), 1500);
      } catch (error) {
        console.error("Error al eliminar:", error);
      } finally {
        this.mostrarLoaderDos = false;
        this.proveedorSeleccionado = null;
      }
    },
    async manejarActualizacion() {
      this.mostrarModalEditar = false;
      this.mostrarExito = true;
      setTimeout(() => (this.mostrarExito = false), 1500);
      await this.obtenerProveedores();
    },
    cancelarEliminacion() {
      this.mostrarModalConfirmacion = false;
      this.proveedorSeleccionado = null;
      this.TipoProveedorAEliminar = null;
    },
    async agregarProveedor() {
      this.mostrarModalAgregar = false;

      this.mostrarExito = true;
      setTimeout(() => (this.mostrarExito = false), 1500);

      await this.obtenerProveedores();
    },
  },
  mounted() {
    this.obtenerProveedores();
  },
};
</script>

<style scoped>
.header-proveedores {
  justify-content: flex-start;
  display: flex;
  padding: 20px 20px 0px 50px;
  align-items: center;
  margin-bottom: 5px;
}

.tituloModulo {
  font-size: 25px;
  color: #2a428c;
  font-weight: bolder;
  font-style: italic;
  padding: 0;
}

.leyenda-referencia {
  padding: 0px 50px 0px;
  margin-bottom: 15px;
  color: #666;
  font-size: 14px;
  font-style: italic;
}

.leyenda-referencia .icono-info {
  font-style: normal;
  font-weight: bold;
  color: #29b9f6;
  margin-right: 5px;
}

.subtitulo-tabla {
  font-size: 20px;
  color: #29b9f6;
  font-weight: bold;
  text-align: center;
  padding: 10px 0;
  border-bottom: none;
  margin: 0;
}

.area-agregar-proveedor {
  display: flex;
  justify-content: center;
  padding: 10px 0 20px 0;
}

.btn-agregar-principal {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #29b9f6;
  color: #29b9f6;
  height: 42px;
  margin-right: 0;
  z-index: 10;
  border-radius: 8px;
  padding: 0 15px;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
  font-weight: 600;
  cursor: pointer;
}

.btn-agregar-principal:hover {
  background: #29b9f6 0% 0% no-repeat padding-box;
  color: white;
}

.contenedor-tres-tablas {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 30px;
  height: auto;
  overflow-y: visible;
}

.seccion-tabla-individual {
  padding: 0;
  margin-bottom: 0;
}

.default {
  border-collapse: collapse;
  width: 100%;
  box-shadow: none;
}

.default th {
  background-color: black;
  color: #fff;
  font-size: 13px;
}

.default td,
.default th {
  border: none;
  padding: 12px 8px;
  text-align: center;
  font-size: 14px;
}

.default tr {
  border-bottom: none;
}

.default tbody tr:last-child {
  border-bottom: 1px solid #e0e0e0;
}

.default tbody tr {
  background-color: white;
}

.tabla-scrollable {
  max-height: none;
  overflow-y: hidden;
  background: white;
  border: none;
}

thead th {
  position: sticky;
  top: 0;
  background-color: #000;
  color: white;
  z-index: 10;
}

.botonesTabla {
  display: flex;
  gap: 3px;
  justify-content: center;
}

.header-proveedores {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 15px 15px 15px;
  margin-bottom: 5px;
}

@media (max-width: 810px) {
  .leyenda-referencia {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 0px;
    padding: 0px 20px 10px;
    font-size: 13px;
  }
}

.btn-agregar-top {
  background-color: #29b9f6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0 20px;
  height: 42px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-agregar-top:hover {
  background-color: #7a3e1a;
  transform: translateY(-1px);
}
</style>